export function mmToIn(mms: number) {
  return mms / 25.4;
}

export function inToMM(inches: number) {
  return inches * 25.4;
}
